/* eslint-disable jsx-a11y/aria-proptypes */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from "react";
import { OverlayTrigger, Tooltip, Row, Col, Button } from "react-bootstrap";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import {
  toAbsoluteUrl,
  sortCaret,
  headerSortingClasses,
  PleaseWaitMessage,
  NoRecordsFoundMessage,
} from "../../../../_metronic/_helpers";
import SVG from "react-inlinesvg";
import { useDispatch, useSelector } from "react-redux";
import { setDraftReturn } from "./reportHeaderSlice";
import { useHistory } from "react-router-dom";
import {
  nonMtkaDetailSuccess,
  nonMTKAFromSet,
} from "../../../modules/ECommerce/_redux/without-rtv/withoutRtvStore";
import { setRtv } from "../../new-return/with-rtv/withrtvSlice";
import { setDraft } from "../../new-return/without-rtv/non-reference/nonRefSlice";
import { createApproval } from "../../new-return/without-rtv/reference/withoutRtvSlice";
import {
  formatDate,
  sizePerPageList,
  showConfirmDialog,
  showDialog,
  showDeleteDialog,
  showErrorDialog,
  showSuccessDialog,
  useForceUpdate,
  formatStatusSo,
  isAfterOrEqual,
  formatDateTime,
  formatDateTimeUtc,
} from "../../../utility";
import { updatePrint } from "../../chief-delivery/deliverySlice";
import { selectUser } from "../../../modules/Auth/_redux/authRedux";
import { setSelected } from "../../new-return/without-rtv/reference/withoutRtvSlice";
import { removeById, postReject } from "./reportHeaderSlice";
import { fetchMultiplePrint } from "../../chief-delivery/deliverySlice";
import LoadingFetchData from "../../../utility/LoadingFetchData";
import Swal from "sweetalert2";

export const ReportHeaderTable = ({
  data,
  page,
  sizePerPage,
  onTableChange,
  totalSize,
  loading,
  handleSearch,
  cutoff,
}) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const user = useSelector(selectUser);
  const forceUpdate = useForceUpdate();

  const [selectedRows, setSelectedRows] = useState([]);
  const [overlay, setOverlay] = useState(false);
  // const openDraft = async (e, column) => {
  //   const formattedData = formatReportHeader(column);
  //   dispatch(nonMtkaDetailSuccess(formattedData));
  //   return new Promise((resolve) => {
  //     resolve(dispatch(nonMTKAFromSet("header")));
  //   }).then(() => {
  //     history.push("/new-return/non-rtv/non-rtv-detail/");
  //   });
  // };

  const openDraft = async (e, column) => {
    const formattedData = formatReportHeader(column);
    dispatch(setSelected(formattedData));
    history.push(`/new-return/non-rtv/non-rtv-detail/`);
  };

  const openDraftNonRef = async (e, column) => {
    const formattedData = formatNonRef(column);
    dispatch(setDraft(formattedData));
    history.push("/new-return/non-rtv/non-reference-draft");
  };

  const openDraftRtv = (e, column) => {
    dispatch(setRtv(column));
    history.push("/new-return/with-rtv/list");
  };

  const openDraftRtvDetail = async (e, column) => {
    const formattedData = formatReportRtvDetail(column);
    dispatch(setRtv(formattedData));
    console.log(formattedData, "formattedData");
    history.push("/new-return/with-rtv/draft/detail");
  };

  const openDraftNonRtvDetail = async (e, column) => {
    const formattedData = formatReportRtvDetail(column);
    dispatch(setRtv(formattedData));
    history.push("/new-return/with-rtv/non-reference");
  };

  const showDetail = (e, column) => {
    history.push(`/report-return/report-header/detail/${column.returnId}`);
  };

  const formatReportHeader = (header) => {
    let formatted = [];
    const list = header.items;
    console.log(header, "here");
    console.log(list, "list");
    list.forEach((item) => {
      const obj = {
        taxInvoiceNo: header.taxInvoiceNo,
        dataSource: header.dataSource,
        customerName: header.customerName,
        altUom: item.altUom,
        customerCode: header.customerCode,
        netPrice: header.netPrice,
        blocked: false,
        transactionDate: header.transactionDate,
        blockRemark: "",
        availableQty: item.availableQty,
        qty: item.qty,
        invoiceNo: header.invoiceNo,
        materialName: item.materialName,
        expiredDate: item.expiredDate,
        uom: item.uom,
        materialCode: item.materialCode,
        clientName: header.clientName,
        plantName: header.plantName,
        clientCode: item.clientCode,
        plantCode: header.plantCode,
        batch: item.batch,
        crprgp: item.crprgp,
        uuid: item.returnId,
        returnDetailId: item.returnDetailId,
        returnId: item.returnId,
        nra: false,
        reasonCode: header.reasonCode,
        remark: header.remark,
        attachmentId: item.attachmentId,
        // update seteleh ganti thunk
        division: item.division,
        line: item.line,
        rayonType: item.rayonType,
        sloc: item.sloc,
        returnUom: item.returnUom,
        netPrice: item.netPrice,
        plant: header.plant,
        // plant: item.plant,
        isChanges: header.isChanges,
        // isChanges: item.isChanges,
      };
      formatted.push(obj);
    });
    return formatted;
  };

  const formatReportRtvDetail = (header) => {
    let formatted = [];
    const list = header.items;
    // console.log(header, "here");
    list.forEach((item) => {
      const obj = {
        taxInvoiceNo: header.taxInvoiceNo,
        dataSource: header.dataSource,
        customerName: header.customerName,
        altUom: item.altUom,
        customerCode: header.customerCode,
        netPrice: header.netPrice,
        transactionDate: header.transactionDate,
        availableQty: item.availableQty,
        qty: item.qty,
        invoiceNo: header.invoiceNo,
        materialName: item.materialName,
        expiredDate: item.expiredDate,
        uom: item.uom,
        materialCode: item.materialCode,
        clientName: header.clientName,
        plantName: header.plantName,
        clientCode: item.clientCode,
        plantCode: header.plantCode,
        batch: item.batch,
        crprgp: item.crprgp,
        uuid: item.returnId,
        returnDetailId: item.returnDetailId,
        returnId: item.returnId,
        nra: false,
        reasonCode: header.reasonCode,
        remark: header.remark,
        attachmentId: item.attachmentId,
        rtvNo: header.rtvNo,
        rtvDate: header.rtvDate,
        rtvReceivingDate: header.rtvReceivingDate,
        remarksRtv: header.remarksRtv,
        // update seteleh ganti thunk
        division: item.division,
        line: item.line,
        rayonType: item.rayonType,
        sloc: item.sloc,
        returnUom: item.returnUom,
        netPrice: item.netPrice,
        taxToNPWP: header.TaxToNPWP,
        plant: header.plant,
        // plant: item.plant,
        isChanges: header.isChanges,
      };
      formatted.push(obj);
    });
    return formatted;
  };

  const formatNonRef = (header) => {
    let formatted = [];
    const list = header.items;
    // console.log(header, "here");
    list.forEach((item) => {
      const obj = {
        dataSource: header.dataSource,
        customerName: header.customerName,
        altUom: item.altUom,
        customerCode: header.customerCode,
        netPrice: header.netPrice,
        transactionDate: header.transactionDate,
        qty: item.qty,
        materialName: item.materialName,
        expiredDate: item.expiredDate,
        uom: item.uom,
        returnUom: item.returnUom,
        materialCode: item.materialCode,
        clientName: header.clientName,
        plantName: header.plantName,
        clientCode: item.clientCode,
        plantCode: header.plantCode,
        batch: item.batch,
        crprgp: item.crprgp,
        uuid: item.returnId,
        returnDetailId: item.returnDetailId,
        returnId: item.returnId,
        nra: false,
        reasonCode: header.reasonCode,
        remark: header.remark,
        attachmentId: item.attachmentId,
        distributionChannel: header.distributionChannel,
        customerPODate: header.customerPODate,
        division: item.division,
      };
      formatted.push(obj);
    });
    return formatted;
  };

  const dateFormatter = (cell) => {
    if (cell === "0001-01-01T00:00:00Z") {
      return <span> </span>;
    } else if (cell === "0001-01-01") {
      return <span> </span>;
    } else if (cell === null) {
      return <span> </span>;
    } else {
      return <span>{formatDate(cell)}</span>;
    }
  };

  const statusColumnFormatter = (cellContent, row) => {
    console.log(cellContent, "cellContent");
    console.log(row, "row");
    let style = "";
    if (cellContent === "Draft") {
      style = "warning";
    } else if (cellContent === "In Progress") {
      style = "info";
    } else if (cellContent === "Completed") {
      style = "success";
    } else if (cellContent === "Rejected") {
      style = "danger";
    }
    return (
      <span
        className={`label label-lg label-light-${style} label-inline label-width-status`}
      >
        {cellContent}
      </span>
    );
  };

  const approvalColumnFormatter = (cellContent, row) => {
    let style = "";
    if (cellContent === "Pending On Client") {
      style = "warning";
    } else if (cellContent === "Pending On QA-HO") {
      style = "info";
    } else if (cellContent === "Pending On FSS/ASM/BM") {
      style = "success";
    } else if (cellContent === "Pending On BRQA") {
      style = "danger";
    } else if (cellContent === "Pending On Chief Warehouse") {
      style = "info";
    } else if (cellContent === "Pending On Chief Delivery") {
      style = "info";
    }
    return (
      <span
        className={`label label-lg label-light-${style} label-inline label-pending label-width-pending`}
      >
        {cellContent}
      </span>
    );
  };

  const formatApprovalStatus = (cell, row) => {
    let label = "";
    if (row.approvalStatus === "D") {
      label = "Draff";
    } else if (row.approvalStatus === "A" && row.statusReject === true) {
      label = "Rejected";
    } else if (row.approvalStatus === "A" && row.statusReject === false) {
      label = "Completed";
    } else if (row.approvalStatus === "W") {
      label = "In Progress";
    } else if (row.approvalStatus === "R") {
      label = "Rejected";
    }

    let style = "";
    if (row.approvalStatus === "D") {
      style = "warning";
    } else if (row.approvalStatus === "A" && row.statusReject === true) {
      style = "danger";
    } else if (row.approvalStatus === "A" && row.statusReject === false) {
      style = "success";
    } else if (row.approvalStatus === "W") {
      style = "info";
    } else if (row.approvalStatus === "R") {
      style = "danger";
    }
    return (
      <span
        className={`label label-lg label-light-${style} label-inline label-width-pending`}
      >
        {label}
      </span>
    );
  };
  const printFormatter = (cell, column, row) => {
    const url = `${process.env.REACT_APP_API_URL}/return/${column.retNumber}/form`;
    const allowedSteps = ["CD", "CW", "END"];
    const isAllowed = allowedSteps.includes(column.stepCode);

    const handleClick = async (actionType) => {
      if (!isAllowed) return; // Kalau tidak diizinkan, stop di sini

      if (actionType === "CANNOT") {
        showDialog("Cannot Printed , To be create I Return");
      } else {
        const confirmMessage =
          actionType === "REPRINT"
            ? "Are you sure want to Reprint this"
            : "Are you sure want to Print this";

        const action = await showConfirmDialog(confirmMessage);
        if (action.isConfirmed) {
          dispatch(updatePrint(column.retNumber));
          window.open(url, "_blank").focus();
        }
      }
    };

    let iconType, tooltip;
    if (column.retNumber.startsWith("DRF")) {
      iconType = "/media/svg/icons/Code/Warning-2.svg";
      tooltip = "Cannot Printed";
    } else if (column.printStatus === "Y") {
      iconType = "/media/svg/icons/Files/File-done.svg";
      tooltip = "Reprint";
    } else {
      iconType = "/media/svg/icons/Devices/Printer.svg";
      tooltip = "Not Printed";
    }

    const actionType = column.retNumber.startsWith("DRF")
      ? "CANNOT"
      : column.printStatus === "Y"
      ? "REPRINT"
      : "PRINT";

    return (
      <OverlayTrigger overlay={<Tooltip id="tooltip">{tooltip}</Tooltip>}>
        <span
          className={`btn btn-icon btn-light btn-hover-primary btn-sm mx-3 ${
            !isAllowed ? "pe-none opacity-50" : ""
          }`}
          style={{ cursor: isAllowed ? "pointer" : "not-allowed" }}
          onClick={() => handleClick(actionType)}
        >
          <span className="svg-icon svg-icon-md svg-icon-primary">
            <SVG src={toAbsoluteUrl(iconType)} />
          </span>
        </span>
      </OverlayTrigger>
    );
  };

  const handleDelete = async (e, row, rowIndex) => {
    console.log(row, "row");
    const id = { retNumber: `${row.retNumber}` };
    console.log("id", id);

    const action = await showDeleteDialog(
      `Are you sure want to delete?<br><strong>${row.retNumber}</strong>`
    );
    if (action.isConfirmed) {
      try {
        const response = await dispatch(removeById(row.returnId));
        if (response.payload.data.status === 200) {
          const action = await showSuccessDialog(response.payload.message);
          if (action.isConfirmed) await window.location.reload();
        } else {
          showErrorDialog(response.payload.data.message);
          // if (response.payload.message !== "") {
          //   console.log("masuk if");
          // } else {
          //   console.log("masuk else");

          //   showErrorDialog(response.payload.data.message);
          // }
        }
      } catch (error) {
        console.log(error);
      }
    }
  };

  const handleReject = async (e, row, rowIndex) => {
    const id = { retNumber: `${row.retNumber}` };

    // const action = await showConfirmDialog(
    //   `Are you sure want to reject?<br><strong>${row.retNumber}</strong>`
    // );

    // if (action.isConfirmed) {
    //   try {
    //     const response = await dispatch(postReject(row.retNumber));
    //     if (response.payload.data.status === 200) {
    //       const action = await showSuccessDialog(response.payload.message);
    //       if (action.isConfirmed) await window.location.reload();
    //     } else {
    //       showErrorDialog(response.payload.data.message);
    //     }
    //   } catch (error) {
    //     console.log(error);
    //   }
    // }

    const { value: remark } = await Swal.fire({
      title: `Are you sure want to reject?<br><strong>${row.retNumber}</strong>`,
      input: "text",
      inputLabel: "Please input remarks first",
      inputPlaceholder: "Enter your remarks",
      showCancelButton: true,
      inputValidator: (value) => {
        if (!value) {
          return "You need to write remarks!";
        }
      },
    });

    if (remark) {
      const id = row.retNumber;
      const params = {
        remark: remark,
      };
      try {
        const response = await dispatch(postReject({ params, id }));
        if (response.payload.status === 200) {
          console.log(response, "response");
          const action = await showSuccessDialog(response.payload.data.data);
          if (action.isConfirmed) await window.location.reload();
        } else {
          showErrorDialog(response.payload.data.message);
        }
      } catch (error) {
        showErrorDialog(error.message);
      }
    }
  };

  const deleteFormatter = (e, row, rowIndex) => {
    return (
      <div>
        {row.retNumber.substring(0, 3) === "DRF" && (
          <>
            <OverlayTrigger
              overlay={<Tooltip id="products-delete-tooltip">Delete</Tooltip>}
            >
              <div
                className="btn btn-icon btn-light btn-hover-danger btn-sm"
                onClick={() => handleDelete(e, row, rowIndex)}
              >
                <span className="svg-icon svg-icon-md svg-icon-danger">
                  <SVG
                    src={toAbsoluteUrl("/media/svg/icons/General/Trash.svg")}
                  />
                </span>
              </div>
            </OverlayTrigger>
          </>
        )}
        {row.lastApprovalUser === "" &&
          row.printStatus === "N" &&
          row.retNumber.substring(0, 3) !== "DRF" && (
            <OverlayTrigger
              overlay={<Tooltip id="products-delete-tooltip">Reject</Tooltip>}
            >
              <div
                className="btn btn-icon btn-light btn-hover-danger btn-sm"
                onClick={() => handleReject(e, row, rowIndex)}
              >
                <span className="svg-icon svg-icon-md svg-icon-danger">
                  <SVG
                    src={toAbsoluteUrl(
                      "/media/svg/icons/Code/Error-circle.svg"
                    )}
                  />
                </span>
              </div>
            </OverlayTrigger>
          )}
      </div>
    );
  };

  const printAllowed = ["FSS", "ADMIN", "ADMINISTRATOR"];
  const deleteAllowed = ["SALES_SERVICE", "ADMIN", "ADMINISTRATOR"];

  const role = user.roles.map((e) => {
    return e.roleName;
  });

  const checkRoles = (userRoles, allowedRoles) => {
    return userRoles.some((e) => allowedRoles.includes(e));
  };
  const cekRoles = checkRoles(role, printAllowed);
  const cekDeleteRole = checkRoles(role, deleteAllowed);

  console.log(cekRoles, "cekRoles");

  const fareyeFormatter = (cellContent, row) => {
    let label = "";

    // Cari data plant berdasarkan PlantCode
    const plantCutoff = cutoff.find(
      (plant) => plant.plantCode === row.plantCode
    );

    // Ambil cutOffDate (kalau ada)
    const cutoffDate = plantCutoff?.cutOffDate || "";

    if (row.fareyeStatus !== "") {
      label = row.fareyeStatus;
    } else if (
      row.fareyeStatus === "" &&
      row.firstPrintDate === "0001-01-01T00:00:00Z"
    ) {
      label = "Not Send";

      // CASE 2: Belum ada status + ada error umum
    } else if (row.fareyeStatus === "" && row.fareyeLastError !== "") {
      label = "Error";
    } else if (
      row.fareyeStatus === "" &&
      row.firstPrintDate !== "0001-01-01T00:00:00Z"
    ) {
      label = "Waiting";
    } else if (row.fareyeStatus !== "") {
      label = row.fareyeStatus;
    } else {
      label = cellContent;
    }

    // Cutoff override
    if (
      row.fareyeStatus === "" &&
      row.firstPrintDate !== "0001-01-01T00:00:00Z" &&
      row.fareyeLastError === ""
    ) {
      if (!cutoffDate) {
        // Kalau cutoffDate kosong
        label = "Irrelevant - Cut Off";
      } else {
        // Kalau cutoffDate ada
        label = isAfterOrEqual(row.firstPrintDate, cutoffDate)
          ? "Waiting"
          : "Irrelevant - Cut Off";
      }
    }

    // Style mapping
    let style = "success";
    if (label === "Not Send" || label === "Error") {
      style = "danger";
    } else if (label === "Waiting") {
      style = "warning";
    } else if (label === "Irrelevant - Cut Off") {
      style = "primary";
    } else if (label === "Irrelevant - Plant") {
      style = "primary";
    }

    return (
      <span
        className={`label label-lg label-light-${style} label-inline label-width-pending-status`}
      >
        {label}
      </span>
    );
  };

  const columns = [
    {
      text: "No",
      dataField: "no",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
    },
    {
      dataField: "returnId",
      text: "id",
      hidden: true,
    },
    {
      dataField: "detail",
      text: "Detail",
      formatter: (cell, column, formatExtraData) => {
        return (
          <div>
            <OverlayTrigger
              overlay={<Tooltip id="products-edit-tooltip">Detail</Tooltip>}
            >
              <a
                className="btn btn-icon btn-light btn-hover-primary btn-sm mx-3"
                onClick={(e) => {
                  if (
                    column.retNumber.substring(0, 3) === "DRF" &&
                    column.returnType === "MTKA" &&
                    column.items.length > 0
                  ) {
                    openDraftRtvDetail(e, column);
                  } else if (
                    column.retNumber.substring(0, 3) === "DRF" &&
                    column.returnType === "NONREFMTKA" &&
                    column.items.length > 0
                  ) {
                    openDraftNonRtvDetail(e, column);
                  } else if (
                    column.retNumber.substring(0, 3) === "DRF" &&
                    column.returnType === "MTKA"
                  ) {
                    openDraftRtv(e, column);
                  } else if (
                    column.retNumber.substring(0, 3) === "DRF" &&
                    column.returnType === "NONMTKA"
                  ) {
                    openDraft(e, column);
                  } else if (
                    column.retNumber.substring(0, 3) === "DRF" &&
                    column.returnType === "NOREFNONMTKA"
                  ) {
                    openDraftNonRef(e, column);
                  } else {
                    showDetail(e, column);
                  }
                }}
              >
                <span className="svg-icon svg-icon-md svg-icon-primary">
                  <SVG
                    src={toAbsoluteUrl(
                      "/media/svg/icons/Communication/Write.svg"
                    )}
                  />
                </span>
              </a>
            </OverlayTrigger>
          </div>
        );
      },
    },
    {
      text: "Action",
      dataField: "action",
      sort: true,
      hidden: !cekDeleteRole,
      formatter: deleteFormatter,
    },
    {
      text: "Print FPRE",
      dataField: "Print FPRE",
      sort: true,
      hidden: !cekRoles,
      sortCaret: sortCaret,
      headerSortingClasses,
      formatter: printFormatter,
    },
    {
      text: "APL Return Number ",
      dataField: "retNumber",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
    },
    {
      text: "SAP Sales Order",
      dataField: "soNo",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
    },
    {
      text: "SAP Inv Return",
      dataField: "invoiceNoSap",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
    },
    {
      text: "RTV Number",
      dataField: "rtvNo",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
    },
    {
      text: "RTV Date",
      dataField: "rtvDate",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      formatter: dateFormatter,
    },
    {
      text: "Sales Office",
      dataField: "salesOffice",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
    },
    // {
    //   text: "Sales Office Name",
    //   dataField: "salesName",
    //   sort: true,
    //   sortCaret: sortCaret,
    //   headerSortingClasses,
    // },
    {
      text: "Plant Code",
      dataField: "plantCode",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
    },
    {
      text: "Plant Name",
      dataField: "plantName",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
    },
    {
      text: "Reason Code",
      dataField: "reasonCode",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
    },
    {
      text: "Reason Name",
      dataField: "reasonName",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
    },
    {
      text: "User Create",
      dataField: "createdUserName",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
    },
    {
      text: "Create Date Time",
      dataField: "createdDate",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      formatter: dateFormatter,
    },
    {
      text: "Invoice Ref Number",
      dataField: "invoiceNo",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
    },
    {
      text: "Customer Code",
      dataField: "customerCode",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
    },
    {
      text: "Customer Name",
      dataField: "customerName",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
    },
    {
      text: "Customer Group 3",
      dataField: "customerGroup3",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
    },
    {
      text: "Address",
      dataField: "address",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "280px" },
    },
    {
      text: "Approval Status",
      dataField: "status",
      sort: true,
      sortCaret: sortCaret,
      formatter: formatApprovalStatus,
      headerSortingClasses,
      headerStyle: () => {
        return { width: "20%" };
      },
    },
    {
      text: "Pending Process",
      dataField: "stepName",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      formatter: approvalColumnFormatter,
    },
    {
      text: "pending User",
      dataField: "pendingUser",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "230px" },
    },
    {
      text: "fareye Status",
      dataField: "fareyeStatus",
      sort: true,
      sortCaret,
      headerSortingClasses,
      formatter: fareyeFormatter,
      align: "center",
      headerStyle: () => {
        return { width: "20%" };
      },
      style: { minWidth: "180px" },
    },
    {
      text: "Fareye Date Time",
      dataField: "FareyeDate",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      formatter: formatDateTimeUtc,
      style: { minWidth: "180px" },
    },
    {
      text: "Last Approved By",
      dataField: "lastApprovalUser",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
    },
    {
      text: "Last Approved Date",
      dataField: "lastApprovalDate",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      formatter: dateFormatter,
    },
    {
      text: "SO Status",
      dataField: "soStatus",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      formatter: formatStatusSo,
    },
    {
      text: "SO Response",
      dataField: "soLastError",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
    },
  ];

  const options = {
    page: page,
    sizePerPage: sizePerPage,
    showTotal: true,
    totalSize: totalSize,
    sizePerPageList: sizePerPageList,
  };

  const onSelectRow = {
    mode: "checkbox",
    clickToSelect: true,
    hideSelectColumn: !cekRoles,

    onSelectAll: (isSelect) => {
      if (isSelect) {
        setSelectedRows(data);
      } else {
        setSelectedRows([]);
      }
    },
    onSelect: (row, isSelect, rowIndex) => {
      if (isSelect) {
        setSelectedRows([...selectedRows, row]);
      } else {
        const index = selectedRows.indexOf(row);
        if (index > -1) {
          selectedRows.splice(index, 1);
        }
      }
    },
  };

  const handlePrint = async () => {
    const allowedSteps = ["CD", "CW", "END"];
    const invalidItems = selectedRows.filter(
      (item) => !allowedSteps.includes(item.stepCode)
    );

    if (invalidItems.length > 0) {
      showErrorDialog(
        `Some selected items cannot be printed (invalid Pending Process).`
      );
      return; // Stop fungsi kalau ada yang tidak sesuai
    }

    const data = selectedRows.map((item) => item.retNumber);
    const listData = data.toString();
    const _listData = listData.replaceAll(",", "|");
    setOverlay(true);

    try {
      for (let i = 0; i < data.length; i++) {
        forceUpdate();
        const response = await dispatch(updatePrint(data[i]));
        if (response.payload.status !== 200) {
          setOverlay(false);
          showErrorDialog(response.payload.message);
          return;
        }
      }
    } catch (error) {
      setOverlay(false);
      showErrorDialog("Error: something went wrong");
      return;
    }

    try {
      const response = await dispatch(fetchMultiplePrint(_listData));
      if (response.payload.status === 200) {
        const blob = new Blob([response.payload.data], {
          type: "application/pdf",
        });
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = "FPRE.pdf";
        link.click();

        setOverlay(false);
        handleSearch();
      } else {
        setOverlay(false);
        showErrorDialog(response.payload.message);
      }
    } catch (error) {
      setOverlay(false);
      showErrorDialog(error.message);
    }
  };

  return (
    <>
      <LoadingFetchData active={overlay} />

      <BootstrapTable
        remote
        // wrapperClasses="table-responsive"
        classes="table table-head-custom table-vertical-center"
        bootstrap4
        bordered={false}
        keyField="returnId"
        data={data}
        columns={columns}
        pagination={paginationFactory(options)}
        onTableChange={onTableChange}
        selectRow={onSelectRow}
        hover
      >
        <PleaseWaitMessage entities={loading ? null : data} />
        <NoRecordsFoundMessage entities={loading ? null : data} />
      </BootstrapTable>
      {/* Footer */}

      {checkRoles(role, printAllowed) && (
        <Row className="mt-4">
          <Col md={1} xs={6} className="mb-5 mr-2">
            <Button
              variant="primary"
              onClick={() => {
                if (selectedRows.length > 0) {
                  handlePrint();
                } else {
                  showDialog("Please select row first");
                }
              }}
            >
              Print
            </Button>
          </Col>
        </Row>
      )}
    </>
  );
};
